module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#news",
      toString: function () {
        return this.url;
      }
    }